/* eslint-disable no-shadow */
/* eslint-disable func-names */
/* eslint-disable max-len */
/* eslint-disable no-return-assign */

/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useHistory, useParams } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import {
  Card, CardBody, Col, ButtonToolbar, Button, Modal, ModalHeader, ModalBody, ModalFooter, Progress, Row,
} from 'reactstrap';
import { message } from 'antd';
import { URL_QUIZ } from '../../../../../../utils/EndPoints';
import { LOCALSTORAGE_TOKEN } from '../../../../../../utils/Types';
import renderCheckBoxField from '../../../../../../shared/components/form/CheckBox';

const EditQuizForm = (stateOri) => {
  const history = useHistory();
  const params = useParams();

  const [isEditable, setEditable] = useState(false);
  const [progress, setProgress] = useState();

  // loading
  const [loading, setLoading] = useState(false);

  const { location } = history;
  const { state } = location;
  const { data } = state;
  const { initialize } = stateOri;
  const [confirm, setConfirm] = useState(0);
  const [modal, setModal] = useState(false);
  const toggle = (id) => {
    setConfirm(id);
    setModal(!modal);
  };

  useEffect(() => {
    initialize(data);
  }, []);

  return (
    <Col md={12} lg={12}>
      <Card className="card--not-full-height">
        <CardBody className="dashboard__booking-card">
          <form
            className="form"
            onSubmit={(e) => {
              e.preventDefault();
              const data = new FormData();
              data.append('name', e.target.name.value);
              data.append('isFinalQuiz', e.target.isFinalQuiz.checked);
              const token = localStorage.getItem(LOCALSTORAGE_TOKEN);
              const options = {
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Token ${token}`,
                },
                onUploadProgress: (data) => {
                  setProgress(Math.round((100 * data.loaded) / data.total));
                },
              };
              setLoading(true);
              axios.patch(`${URL_QUIZ}${params.id}/`, data, options)
                .then((res) => {
                  history.push({
                    pathname: `/admin/course-material/${res.data.topicId}`,
                    search: '?tabs=2',
                  });
                  setLoading(false);
                })
                .catch(() => {
                  setLoading(false);
                  message.error('Something went wrong!');
                });
            }}
          >
            <span className="form__form-group-label">Title Exam</span>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Field
                  name="name"
                  disabled={!isEditable}
                  component="input"
                  type="text"
                />
              </div>
            </div>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Field
                  name="isFinalQuiz"
                  disabled={!isEditable}
                  component={renderCheckBoxField}
                  label="Is this exam for final examination? required for certification"
                />
              </div>
            </div>
            {loading && (
              <Card>
                <Col md={12} lg={12}>
                  <Progress animated value={progress}>{progress}%</Progress>
                </Col>
              </Card>
            )}
            <ButtonToolbar className="form__button-toolbar">
              <Row className="mt-4">
                <Col md={12}>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setEditable(!isEditable)}
                    color={isEditable ? 'danger' : 'primary'}
                  >
                    {!isEditable ? 'Change' : 'Cancel'}
                  </button>
                  {isEditable && (
                    <button
                      type="submit"
                      className="btn btn-primary"
                    >
                      Save
                    </button>
                  )}
                  {isEditable === false && (
                    <button
                      type="button"
                      size="sm"
                      onClick={() => toggle(data?.id)}
                      className="btn btn-danger"
                    >
                      Delete
                    </button>
                  )}
                  <Modal
                    toggle={toggle}
                    isOpen={modal}
                    backdrop={false}
                  >
                    <ModalHeader toggle={toggle}>
                      Delete Exam
                    </ModalHeader>
                    <ModalBody>
                      Are you sure you want to Delete this Exam?
                    </ModalBody>
                    <ModalFooter>
                      <Button
                        onClick={() => {
                          const token = localStorage.getItem(LOCALSTORAGE_TOKEN);
                          const options = {
                            headers: {
                              'Content-Type':
                            'application/json',
                              Authorization: `Token ${token}`,
                            },
                          };
                          axios
                            .delete(
                              `${URL_QUIZ}${confirm}`,
                              options,
                            )
                            .then(() => {
                              history.push({
                                pathname: `/admin/course-material/${data.topicId}`,
                                search: '?tabs=2',
                              });
                            })
                            .catch(() => {
                              message.error('Something went wrong!');
                            });
                        }}
                      >
                        Delete
                      </Button>
                    </ModalFooter>
                  </Modal>
                </Col>
              </Row>
            </ButtonToolbar>
          </form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default reduxForm({
  form: 'edit_quiz', // a unique identifier for this form
})(EditQuizForm);
